import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

// Gestion des styles
import "assets/fonts/fonts.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeProvider } from "emotion-theming";
import { theme } from "styles/Theme.js";
// eslint-disable-next-line
import Global from "styles/Global";
import 'tippy.js/dist/tippy.css'; // optional

// Listing des routes
import routes from "routes";

//import de Provider qui va permettre de fournir le store aux composants React
import { Provider } from "react-redux";
import { store, persistor } from "state/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from 'redux-persist';

// Gestion error
import ErrorBoundary from "utils/ErrorBoundary";

// Numero de version affiche en pied de page
import AppVersion from "views/universal/Layout/AppVersion";

// Reinitialisation du store au déploiement.
// Le garde `deployVer &&` est indispensable : si la variable est absente du
// build, l'ancienne version stockait la chaine "undefined" et rechargeait la
// page en boucle infinie (ecran blanc).
const deployVer = process.env.REACT_APP_VERSION;
const curVersion = localStorage.getItem('version');

if (deployVer && curVersion !== deployVer) {
  const hadPreviousVersion = Boolean(curVersion) && curVersion !== 'undefined';
  localStorage.setItem('version', deployVer);
  // purge() est asynchrone : on attend qu'il soit termine avant de recharger,
  // sinon le store persiste peut survivre au reload.
  persistStore(store).purge().then(() => {
    // Inutile de recharger a la premiere visite : il n'y a rien a purger.
    if (hadPreviousVersion) document.location.reload();
  });
}

const App = (props) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <>
            <Router>
              <ErrorBoundary>
                <Switch>
                  {routes.map((route, key) => (
                    <Route
                      exact
                      path={route.path}
                      component={route.component}
                      key={key}
                    />
                  ))}
                </Switch>
              </ErrorBoundary>
            </Router>
            <AppVersion />
          </>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
